import './styles/UnderReviewPage.scss';

import { useLottie } from 'lottie-react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';

import { LOGIN_MSG } from '../../constants';
import { useClassHelper } from '../../hooks';
import { SignOutType } from '../../types';
import { Button } from '../Button';
import { Card } from '../Card';
import { Stack } from '../Stack';
import { Heading, Paragraph } from '../Typography';
import groovyWalkAnimation from './helpers/under-review-lottie.json';

const componentName = 'c-UnderReview';

interface Props {
  signOut: ({ ...params }: SignOutType) => void;
  logoUrl: string;
  bgImage?: string;
}

interface LocationState {
  status?: string;
}

export const UnderReviewPage = ({ signOut, bgImage }: Props) => {
  const location = useLocation();
  const state = location.state as LocationState;

  const { t } = useTranslation(['pages']);
  const c = useClassHelper(componentName);

  const options = {
    animationData: groovyWalkAnimation,
    loop: true,
  };

  const { View } = useLottie(options);

  const status = state?.status ?? 'underReview';

  return (
    <section className={componentName}>
      {/* Background */}
      <figure className={c('__bg-pattern')}>
        {bgImage && <img src={bgImage} alt="bg parrent" aria-hidden />}
      </figure>
      {/* Content */}
      <div className={c('__content')}>
        <Card>
          <figure className={c('__lottie')}>{View}</figure>
          <Stack direction="column" gap={6}>
            <Heading level={2}>
              {t(`pages:underReview:${status}_title`)}
            </Heading>
            <Paragraph>{t(`pages:underReview:${status}_message`)}</Paragraph>
            <footer className={c('__footer')}>
              <Button
                type="button"
                classes={{ button: c('__footer-button') }}
                onClick={() => signOut({ appMsg: LOGIN_MSG.SIGN_OUT_SUCCESS })}
              >
                {t(`pages:underReview:button`)}
              </Button>
            </footer>
          </Stack>
        </Card>
      </div>
    </section>
  );
};

export default UnderReviewPage;
